module.exports = "### Border\n\nWe use borders for a wide variety of UI including Forms, Buttons, Lists and to group content.\n"